import {
  addDoc,
  collection,
  doc,
  onSnapshot,
  orderBy,
  query,
  updateDoc,
} from "firebase/firestore";
import Moment from "moment";
import React, { useEffect, useRef, useState } from "react";
import { Image } from "react-bootstrap";
import Form from "react-bootstrap/Form";
import { FaLocationArrow } from "react-icons/fa";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { v4 as uuidv4 } from "uuid";
import Loader from "../../Components/Loader/Loader";
import { db } from "../../Firebase";
import { InsertChatApi } from "../../Services/Api/InsertChat";
import { GetSlUserName, getUser } from "../../Utils/Auth/LocalStorage";

const Chat = ({ ToggleChat, selectedChannel, ...props }) => {
  const data_product_type = 1;
  const navigate = useNavigate();
  const get_uuid = uuidv4();
  const parameter = useParams();
  const location = useLocation();
  const userdata = getUser();
  const SlUserName = GetSlUserName();
  const com_id = parameter.id;
  const BunsinessName = location?.state?.businessName;
  const ProductName = location?.state?.productName;
  const productImage = location?.state?.productImage;
  const bu_id = location?.state?.bu_id;
  const product_id = location?.state?.product_id;
  const mms_city_id = location?.state?.mms_city_id;
  const marketplace_business_id = location?.state?.marketplace_business_id

  const [chatMessage, setChatMessage] = useState("");
  const [allMessages, setAllMessages] = useState([]);
  const [errorMessage, setErrorMessage] = useState("");
  const [loading, setLoading] = useState(false);

  const messagesEndRef = useRef(null);
  const userId = localStorage.getItem("userId");
  const username = localStorage.getItem("userName");
  const userName = userdata ? userdata.first_name : SlUserName;

  const scrollToBottom = () => {
    messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  useEffect(() => {
    scrollToBottom();
  }, [allMessages]);

  useEffect(() => {
    if (!com_id) return;

    setLoading(true);
    const messagesQuery = query(
      collection(db, com_id),
      orderBy("createdAt", "asc"),
    );

    const unsubscribe = onSnapshot(
      messagesQuery,
      (snapshot) => {
        const chatList = snapshot.docs.map((doc) => {
          const data = doc.data();
          return {
            id: doc.id,
            messages: data.text,
            createdAt: data.createdAt,
            user_id: data.user?._id,
            user_name: data.user?.name,
          };
        });

        setAllMessages(chatList);
        setLoading(false);
      },
      (error) => {
        console.error("Firestore subscription error:", error);
        setLoading(false);
      },
    );

    updateChatField();

    return () => unsubscribe();
  }, [com_id]);

  const updateChatField = () => {
    allMessages.forEach((docData) => {
      if (docData.read === false && docData.user_id !== userdata?.uid) {
        chatUpdate(docData.id);
      }
    });
  };

  async function chatUpdate(docID) {
    try {
      const userDocRef = doc(db, com_id, docID);
      await updateDoc(userDocRef, { read: true });
    } catch (err) {
      console.error("Error updating read status:", err);
    }
  }

  const sendMessage = async (e) => {
    if (e) e.preventDefault();
    if (chatMessage.trim() === "" || com_id === "voucher_coupon") {
      setErrorMessage("Please enter a message!");
      return;
    }

    setErrorMessage("");
    try {
      if (userId && com_id !== "voucher_coupon") {
        await addDoc(collection(db, com_id), {
          _id: get_uuid,
          text: chatMessage,
          createdAt: new Date(),
          user: {
            _id: userId,
            name: userName,
          },
        });

        const messageData = {
          bu_id: marketplace_business_id ? null : bu_id,
          channel_id: com_id,
          product_id: product_id,
          help_reason: chatMessage,
          product_type: data_product_type,
          mms_city_id: mms_city_id ? mms_city_id : null,
          marketplace_business_id:marketplace_business_id ? marketplace_business_id : null
        };

        InsertChattoDB(messageData);
      }
    } catch (error) {
      console.error("Chat send error:", error);
    }
    setChatMessage("");
  };

  const InsertChattoDB = async (messageData) => {
    try {
      const MessageData = await InsertChatApi(messageData, () => {
        navigate("/");
      });
      if (MessageData?.status === 200) {
        navigate(`/messages/${com_id.toString()}`, {
          state: { productName: ProductName, businessName: BunsinessName },
        });
      }
    } catch (err) {
      console.error("API Error:", err);
    }
  };

  if (
    com_id !== ":order-related=true" &&
    ToggleChat === false &&
    selectedChannel?.id !== ""
  ) {
    return (
      <>
        {loading ? <Loader /> : null}
        {errorMessage ? (
          <p style={{ textAlign: "center", color: "red" }}>{errorMessage}</p>
        ) : null}
        <div className="chat-main mt-3">
          <div className="chat-header">
            <div className="d-flex align-items-center msg-main1 msg-main2">
              <Image loading="lazy" src={productImage} className="msgpic" />
              <div className="msg-1">
                <p className="msg1-text1">{ProductName}</p>
                <p className="msg1-text2">{BunsinessName}</p>
              </div>
            </div>
          </div>
          <div className="container bootstrap snippets bootdeys">
            <div className="col-md-12">
              <div className="panel" id="chat">
                <div className="panel-body">
                  <div className="chats">
                    {allMessages &&
                      allMessages.map((msg) => {
                        const rawTimestamp = msg.createdAt;
                        const dateObject = rawTimestamp?.toDate
                          ? rawTimestamp.toDate()
                          : new Date(rawTimestamp);
                        const formattedTime =
                          Moment(dateObject).format("DD-MMM-YY hh:mm A");

                        const isCurrentUser =
                          String(msg.user_id) === String(userId) ||
                          msg.user_name === username;

                        return (
                          <div key={msg.id || uuidv4()}>
                            <div
                              className={`chat ${
                                isCurrentUser ? "" : "chat-left"
                              }`}
                            >
                              <div className="chat-body">
                                <div className="chat-content">
                                  <p style={{ color: "black" }}>
                                    {msg.messages}
                                  </p>
                                  <time className="chat-time">
                                    {formattedTime}
                                  </time>
                                </div>
                              </div>
                            </div>
                          </div>
                        );
                      })}
                    <div ref={messagesEndRef} />
                  </div>
                </div>
                <div className="panel-footer">
                  <form onSubmit={sendMessage}>
                    <div className="input-group">
                      <Form.Group className="mb-3" controlId="formBasicEmail">
                        <Form.Control
                          type="text"
                          value={chatMessage}
                          onChange={(e) => setChatMessage(e.target.value)}
                          placeholder="Type a message..."
                          autoComplete="off"
                        />
                        <button
                          className="btn btn-primary chat-send"
                          type="submit"
                        >
                          <FaLocationArrow className="locationArrow" />
                        </button>
                      </Form.Group>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }

  return null;
};

Chat.propTypes = {};

export default Chat;
